import gql from "graphql-tag";

//GetDashboard5Data
export const GET_DASHBOARD_5_TREE_VIEW = gql`
    query ($startDate: String!, $endDate: String!) {
        GetDashboard5Data(startDate: $startDate, endDate: $endDate) {
            code
            success
            message
            results {
                generalPermit {
                    title
                    key
                    b6Permits {
                        title
                        key
                    }
                    facPermits {
                        title
                        key
                        children {
                            title
                            key
                        }
                    }
                    ehsPermits {
                        title
                        key
                        children {
                            title
                            key
                        }
                    }
                }
                toolInstallPermit {
                    title
                    key
                    b6Permits {
                        title
                        key
                        permitCount
                    }
                    facPermits {
                        title
                        key
                        children {
                            title
                            key
                        }
                    }
                    ehsPermits {
                        title
                        key
                        children {
                            title
                            key
                        }
                    }
                }
            }
        }
    }
`;